
import { useSelector } from "react-redux";
import { selectCart } from "../../redux/slices/cart";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartPlus } from "@fortawesome/free-solid-svg-icons";


export const CartIcon = () => {
  const cart = useSelector(selectCart);
  const location = useLocation();
  const navigate = useNavigate();
  
  const handleCart = () => {
     navigate("/cart/listing");
      window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
        <FontAwesomeIcon icon={faCartPlus} onClick={handleCart} />
        {cart.itemCount > 0 &&  (
          <span className="cart-quantity">{cart.itemCount }</span>
        )}
    </>
  );
};
